import { rollup, sum } from 'd3'
import { callApi } from '@local_modules/generic/fetch.js'

export async function loadGroupTransactions (context) {
  console.log('loadGroupTransactions', context)
  const apiUrl = '/api/intercompany/:appAccountId/transactions?dateFrom=:dateFrom&dateTo=:dateTo'

  const data = await callApi(apiUrl, {
    appAccountId: context.browserAppAccount.data.appAccountId,
    dateFrom: context.menuOptions?.optionDateFrom?.selectedValue,
    dateTo: context.menuOptions?.optionDateTo?.selectedValue
  })
  console.log('data', data)
  computeAnalysis(data)

  return data
}

/** Quick local analysis */
function computeAnalysis (data) {
  data.forEach(d => {
    d._ledger_amount_100 = Math.round(parseFloat(d.ledger_amount) * 100)
  })

  const rollupsBySourceId = rollup(data
    , function (groupValues) {
      return {
        // Not in use
        // total_for_reversals: sum(groupValues, function (d) {
        //   return (d.number_of_reversals > 0) ? d._ledger_amount_100 : 0
        // }),
        total_for_no_reversals: sum(groupValues, function (d) {
          return d.has_no_reversal ? d._ledger_amount_100 : 0
        }),
        // total_for_last_journal: sum(groupValues, function (d) {
        //   return (d.is_last_journal_of_source) ? d._ledger_amount_100 : 0
        // }),
        total_for_all_journal: sum(groupValues, function (d) {
          return d._ledger_amount_100
        }),
        // byLastJournal: group(groupValues, d => d.is_last_journal_of_source),
        //
        // Not in use
        // byReversal: group(groupValues, d => d.has_no_reversal),
        groupValues
      }
    },
    function (value) {
      return value.ledger_accounting_source_id
    }
  )
  console.log('rollupsBySourceId', rollupsBySourceId)
  const sourceWithDifferences = [...rollupsBySourceId.values()].filter(d => {
    return d.total_for_no_reversals !== d.total_for_all_journal
  })
  console.log('sourceWithDifferences', sourceWithDifferences)

  const analysis = {
    local_total: sum(data, d => d._ledger_amount_100),
    total_for_last_journal: sum(data, function (d) {
      return (d.is_last_journal_of_source) ? d._ledger_amount_100 : 0
    }),
    total_for_no_reversal: sum(data, function (d) {
      return (d.has_reversal === 0) ? d._ledger_amount_100 : 0
    }),
    sourceWithDifferences
  }
  console.log('analysis', analysis)

  return analysis
}
